import {Injectable} from '@angular/core';
import {Effect, Actions} from '@ngrx/effects';
import * as statsAction from '../actions/stats.action';
import * as hoursAction from '../actions/hours.action';
import {map, switchMap} from 'rxjs/operators';
import {of} from 'rxjs/observable/of';
import {Action} from '@ngrx/store';
import {Observable} from 'rxjs/Observable';
import {StatisticsService} from '../../statistics.service';


@Injectable()
export class StatsEffects {
  constructor(private actions: Actions, private statisticsService: StatisticsService) {
  }

  @Effect()
  fetchStats: Observable<Action> = this.actions.ofType(statsAction.GET_STATS)
    .map((action: statsAction.GetStats) => action.payload)
    .pipe(
      switchMap((body) => {
        return this.statisticsService.fetchStats(body)
          .map(res => new statsAction.GetStatsSuccess(res))
          .catch(error => of(new statsAction.GetStatsError(error)));
      })
    );

  @Effect()
  fetchHours: Observable<Action> = this.actions.ofType(hoursAction.GET_HOURS)
    .map((action: hoursAction.GetHours) => action.payload)
    .pipe(
      switchMap((body) => {
        return this.statisticsService.fetchHours(body)
          .map(res => new hoursAction.GetHoursSuccess(res))
          .catch(error => of(new hoursAction.GetHoursError(error)));
      })
    );
}



// WEBPACK FOOTER //
// /Users/Chetan/Downloads/angular5_admin-master/src/app/statistics/store/effects/stats.effect.ts